let notifyHandler: any = null;

export const setNotifyHandler = (handler) => {
    notifyHandler = handler;
};

const notify = (options) => {
    if (notifyHandler) {
        notifyHandler(options);
    }
};

export default notify;
